import * as React from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap'
import { AccentButton } from '../controls/AccentButton';
import { AccentSpinner } from '../controls/AccentSpinner';
import AccentIcons from '../icons/Icons';
import { queryNoTracking, useQueryAllNoTracking, useQueryArgs } from "../services/DataService";
import { t, accentUtils, showDialog } from '../services/HelperService';
import { AccentDialog } from './AccentDialog';
import { AttachDocumentDlg, documentTypes } from './AttachDocumentDlg';

const query_Job_JobLine_SelectList = queryNoTracking("Job_JobLine_SelectList");
const query_AttachDocumentSuppliersForJob = queryNoTracking("AttachDocumentSuppliersForJob");

function getDocumentJobLineQuery(jobID) {
    return query_Job_JobLine_SelectList.getAll({ jobID: jobID });
}

function getDocumentJobSupplierQuery(jobID) {
    return query_AttachDocumentSuppliersForJob.getAll({ jobID: jobID });
}

export const SelectSketchDlg = React.memo(({ jobID, jobLineID, onClose, defaultSketchName }) => {

    const queryArgs = useQueryArgs({ jobID, jobLineID });
    const [selected, setSelected] = React.useState(null);

    const sketches = useQueryAllNoTracking("JobSketches", queryArgs, 0);

    const close = React.useCallback(async (e) => {
        onClose({
            selected : selected
        });


        if (e.promise) e.promise();

    }, [jobID, jobLineID, onClose, selected]);


    const newSketch = React.useCallback(async (e) => {

        const hasLine = !accentUtils.isEmpty(jobLineID);
        
        const newSketchResult = await showDialog(<AttachDocumentDlg parentInfo={{ Type: "Job", ID: jobID, LineID: jobLineID, defaultSketchName: defaultSketchName }} getLineQuery={hasLine ? undefined : ()=>getDocumentJobLineQuery(jobID)} getSupplierQuery={hasLine ? undefined : ()=>getDocumentJobSupplierQuery(jobID)} lineLabel="application_strings.grids.documents.jobLine" type={documentTypes.sketch} />);

        if (newSketchResult.Successfull && !accentUtils.isEmpty(newSketchResult.Documents)) {
            onClose({
                selected: { ...newSketchResult.Documents[0]}
            });
        }

        if (e.promise) e.promise();

    }, [jobID, jobLineID, onClose, selected, defaultSketchName]);


    let contents = null;

    if (sketches.loading) {
        contents = <AccentSpinner />;
    } else {


        contents = sketches.data.map(d => {
            return <ListGroupItem key={d.ID}
                action
                onClick={() => setSelected(d)}
                tag="button"
            >
                {d.Description}
            </ListGroupItem>
        });
    }

    const allowSelect = !accentUtils.isNull(selected);

    return (
        <AccentDialog
            maxWidth={ 600 }
            onClose={onClose}
            headerContent={t("application_strings.application.dialogs.selectSketch.title")}
            actionsContent={[
                <AccentButton key="2" tagName="addSketchDlgOKBtn" onClick={newSketch}><AccentIcons.New top="5" noPadding style={{ fontSize: "18px" }} />{t("application_strings.application.buttons.sketch")}</AccentButton>,
                <AccentButton key="3" tagName="selectSketchDlgOKBtn" disabled={!allowSelect} onClick={close}>{t("application_strings.application.buttons.select")}</AccentButton>
            ]}
        >
            {contents}
        </AccentDialog>
    );


});
